<template>
  <div class="subscribe-dialog">
    <modal
      name="subscribe-dialog-modal"
      :can-close="true"
    >
      <template #close>
        <sh-icon name="close" size="xsmall" />
      </template>

      <div class="content">
        <div class="content__image">
          <cloudinary-image :image-source="image.src" :alt="image.alt" />
        </div>
        <subscription-form :theme-override="true" />
      </div>
    </modal>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'
import RecaptchaTerms from '~/components/recaptcha-terms'
import CloudinaryImage from '~/components/cloudinary-image'
import { SitecoreApi } from '~/constants/SitecoreApi'
import Modal from '~/components/modal/standard'
import SubscriptionForm from './subscription-form'
import get from '~/helpers/get'

export default {
  name: 'SubscribeDialogModal',

  async fetch () {
    // TODO - lets use a proper handler for graphQL queries - for now we can string it
    const query = 'query ContentData { subscribeDialogBox: item (path: "/sitecore/content/digital-house/Data/Subscribe Dialog Box Data/Subscribe Dialog Box") { ... on SubscribeDialogBox { dialogImage: jssField(name: "image") } } }'

    const { data: { data } } = await this.$axios.post(SitecoreApi.pageContent, { query })

    this.image = {
      src: get(data, 'subscribeDialogBox.dialogImage.image.value.cloudinary_1x1_fill_crop', ''),
      alt: get(data, 'subscribeDialogBox.dialogImage.image.value.alt', '')
    }
  },

  fetchOnServer: false,

  data () {
    return {
      image: {}
    }
  },

  components: {
    ShIcon,
    RecaptchaTerms,
    SubscriptionForm,
    CloudinaryImage,
    Modal
  }
}
</script>

<style lang="scss">
// dimensions are set in accordance to the designs:
// https://www.figma.com/file/MaDMTvLaDPf8VppFvH3tQK/WEB-NorthStar-WIP?node-id=45%3A2926
$subscribe-dialog-max-width: 746px;
$subscribe-image-width: 330px;

.subscribe-dialog {
  .modal-wrap {
    .modal {
      background-color: $color-white;

      @include tablet {
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        max-width: $subscribe-dialog-max-width;
      }
    }

    .modal-inner {
      padding: $space-070 $space-050 $space-060;

      @include tablet {
        padding: $space-060;
      }
    }

    .close-modal-button {
      top: $space-040;
      right: $space-040;
    }
  }

  .content {
    display: flex;
    flex-direction: column;

    @include tablet {
      flex-direction: row;
    }

    &__image {
      display: none;

      @include tablet {
        display: flex;
        flex: 50%;
        margin-right: $space-060;

        img {
          width: $subscribe-image-width;
          height: auto;
        }
      }
    }
  }
}
</style>
